import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  height: calc(100% - 107px);
  background: var(--white);
  padding: 0 3%;
  overflow: auto;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    h1 {
      color: var(--blueDark);
    }

    > div {
      display: flex;
      flex-direction: column;
      text-align: right;
      font-weight: 500;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 20px;

  span {
    font-weight: bold;
    color: var(--blueDark);
  }

  > div {
    margin-top: 5px;
    padding: 5px 20%;
    margin-bottom: 5px;
  }
`;
